import { render, staticRenderFns } from "./ServicesandSolutions.vue?vue&type=template&id=994faa3a&scoped=true"
import script from "./ServicesandSolutions.vue?vue&type=script&lang=js"
export * from "./ServicesandSolutions.vue?vue&type=script&lang=js"
import style0 from "./ServicesandSolutions.vue?vue&type=style&index=0&id=994faa3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "994faa3a",
  null
  
)

export default component.exports